import LoadingButton from '@mui/lab/LoadingButton';
import { AppBar, Button, Toolbar, Tooltip } from '@mui/material';

interface MobileActionsProps {
  onClose: () => void;
  onSubmit: () => void;
  submitting: boolean;
  isFormValid: boolean;
  missingFieldsMessage: string;
}

export default function MobileActions({
  onClose,
  onSubmit,
  submitting,
  isFormValid,
  missingFieldsMessage,
}: MobileActionsProps) {
  return (
    <AppBar
      sx={{
        position: 'sticky',
        top: 0,
        right: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderColor: 'rgba(255, 255, 255, 0.3)',
            color: 'white',
            '&:hover': {
              borderColor: 'white',
            },
          }}
        >
          Cancel
        </Button>
        <Tooltip title={!isFormValid ? missingFieldsMessage : ''} arrow placement="bottom">
          <span>
            {' '}
            {/* Wrapper needed for disabled buttons with tooltips */}
            <LoadingButton
              variant="contained"
              loading={submitting}
              onClick={onSubmit}
              disabled={submitting || !isFormValid}
            >
              Submit Feedback
            </LoadingButton>
          </span>
        </Tooltip>
      </Toolbar>
    </AppBar>
  );
}
